// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nlvqfdktrmrtpmobdwfx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5sdnFmZGt0cm1ydHBtb2Jkd2Z4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg2NzcxNjEsImV4cCI6MjA1NDI1MzE2MX0.UyqzVtZ0uL4iLiIT3x8tktn3BJqlDxFpv1rFJmce6Gs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);